import FileDownload from "js-file-download";
import { downloadNovationContract } from "../../infrastructure/repository/employees-repository";
import { findCompanyId } from "../../infrastructure/repository/company-repository";

export async function downloadNovationContracts(
  idNovationContract,
  employeeLegalId
) {
  const companyId = await findCompanyId();
  const response = await downloadNovationContract(
    companyId,
    idNovationContract
  );

  const filename = `novation-agreement-${employeeLegalId}.pdf`;

  const blob = response.data;
  const myFile = new File([blob], filename, {
    type: "application/pdf",
    lastModified: Date.now(),
  });

  FileDownload(myFile, filename);
}
